import type { IWithId, ValidationReason } from './form-store';

export class ValidationEvent<T extends IWithId | any> {
  type?: string;
  data?: T;
  isSubmitted: boolean = false;
  reason: ValidationReason = 'Change';
  public constructor(init?: Partial<ValidationEvent<T>>) {
    (Object as any).assign(this, init);
  }
}
